import http from "../http";
import api from "../../config/api";
import {
  AddPatientRequest,
  AddPatientResponse,
  PatientListResponse,
  PatientResponse,
} from "../../interfaces/api/patients";

/**
 * Patients API service
 */
const patients = {
  /**
   * Add a new patient
   * @param {AddPatientRequest} body - Patient data
   * @returns {Promise<AddPatientResponse>} API response
   */
  addPatient: (body: AddPatientRequest): Promise<AddPatientResponse> =>
    http.post(api.patients, body),

  /**
   * Get patients list with paging
   * @param {number} page - Page number (1-based)
   * @param {number} pageSize - Number of items per page
   * @returns {Promise<PatientListResponse>} API response
   */
  getPatients: (page: number, pageSize: number): Promise<PatientListResponse> =>
    http.get(`${api.patients}?pageSize=${pageSize}&page=${page}`),

  /**
   * Get patient details by ID
   * @param {string} id - Patient ID
   * @returns {Promise<PatientResponse>} API response
   */
  getPatientById: (id: string): Promise<PatientResponse> =>
    http.get(`${api.patients}/${id}`),

  /**
   * Delete a patient by ID
   * @param {string} id - Patient ID
   * @returns {Promise<any>} API response
   */
  deletePatient: (id: string): Promise<any> =>
    http.post(`${api.patients}/delete/${id}`, {}),
};

export default patients;
